import { AuthConfig } from "angular-oauth2-oidc"
import { environment } from "src/environments/environment"

export const DiscoveryDocumentConfig = {
    url: environment.url,
    logout: environment.logout,

}
export const authConfig: AuthConfig = {
    redirectUri: environment.redirectUri,
    loginUrl: environment.loginUrl,
    responseType: environment.responseType,
    issuer : environment.issuer,
    strictDiscoveryDocumentValidation: environment.strictDiscoveryDocumentValidation,
    tokenEndpoint: environment.tokenEndpoint,
    skipIssuerCheck: environment.skipIssuerCheck,
    clearHashAfterLogin: environment.clearHashAfterLogin,
    clientId: environment.clientId,
    oidc: environment.oidc,
}